import { AxiosResponse } from 'axios';

import { UpdateUsersBody } from '../pages/tech-support/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

export const postUpdateUsers = async (
	body: UpdateUsersBody,
): Promise<ResponseREST> => {
	return axiosInstance
		.post('update-user', body)
		.then((res: AxiosResponse<ResponseREST>) => res.data)
		.catch((err) => err);
};
